import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  noTemplate: { justifyContent: 'center', alignItems: 'center', padding: 40 },
  templateCardWrapper: {
    width: '100%',
    marginTop: 16,
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
  },
  templateSelectFooter: {
    justifyContent: 'space-between',
    flexDirection: 'row',
    marginTop: 10,
  },
});
